import { render, staticRenderFns } from "./allGoods.vue?vue&type=template&id=fbcd5f7a&scoped=true&"
import script from "./allGoods.vue?vue&type=script&lang=js&"
export * from "./allGoods.vue?vue&type=script&lang=js&"
import style0 from "./allGoods.vue?vue&type=style&index=0&id=fbcd5f7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbcd5f7a",
  null
  
)

export default component.exports